import React from "react";
import styles from "./gainfulButton.module.scss";

const GainfulButton = ({
  text,
  onClick,
  width,
  dataTracking,
  disabled,
  type,
  extraClassName,
  fiftyPercentWidth,
  dataAttr,
}) => (
  <button
    className={`${styles.noselect} ${styles["gainful-button"]}  ${disabled ? styles.disabled : ""} ${
      fiftyPercentWidth ? "fifty-percent-width_mobile_gainful-button" : ""
    } ${extraClassName || ""}`}
    onClick={onClick}
    style={{ width }}
    data-profileclick={`${text} Button`}
    type={type || "button"}
    data-attr={dataAttr || "gainful-button"}
  >
    {text}
  </button>
);

export default GainfulButton;
